import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import DashboardHeader from "./-components/DashboardHeader";

export const Route = createFileRoute("/_main/dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  const pageHeader = <DashboardHeader />;

  return (
    <PageLayout header={pageHeader}>
      <CenteredContentLayout>
        <Outlet />
      </CenteredContentLayout>
    </PageLayout>
  );
}
